import { ExplorableItemType } from '../../ts/models/ContentType';

export interface Draft {
  createdAt: string;
  draftLuid: string;
  model: string;
  name: string;
  parentContentLuid: string;
  project: string;
  site: string;
  thumbnailId: string;
  updatedAt: string;
  user: string;
}

export interface DraftContent {
  parentContentLuid: string;
  draftStatus: string;
  draftLuid: string;
}

export const DraftContentType: ExplorableItemType = 'workbook';

export type GetDraftsRequestBody = Blob;

export enum DraftTagsParentType {
  card = 'CARD',
  list = 'LIST',
  none = 'NONE'
}

export enum DraftTagType {
  neverPublished = 'NEVER_PUBLISHED',
  unpublished = 'DRAFT',
  staticTag = 'STATIC_TAG'  // for draft tags that should not have a tooltip
}

// Drafts state
export type DraftsById = { [key: string]: Draft } | null;

export interface DraftsState {
  readonly drafts: DraftsById;
  readonly isBusy: boolean;
}

export interface DraftWorkbookSpaceProps {
  draftUpdatedAt: string;
  draftLuid: string;
}
